<div class=".fab-btn-doc">
  <button type="button" class="cdx-button cdx-button--primary cdx-button--icon cdx-fab cdx-button--float-right"
    ngbTooltip="{{ 'tooltipWhatsapp' | translate }}" (click)="showDefault()">
    <fa-icon class="fa-fw cdx-button__icon" [icon]="['fab','whatsapp']"></fa-icon>
  </button>
</div>
